<template>
    <el-form ref="form" class="form" :rules="rules" :model="form" :label-width="labelWidth" v-if="canEdit" v-loading="loading">
      <slot>
        <template v-for="(item, index) in formTemplate">
          <el-col v-if="showBy(item)" :key="index" :span="item.col">

              <div v-if="item.type=='tips'" class="form-group-title"><span class="ogc-icon-font ogc-icon-salefill"></span> {{ item.tips }}</div>

              <el-form-item v-else-if="item.type=='display'" :label="item.label" :prop="item.prop">
                  {{ form[item.prop] }}  <span v-if="item.append != undefined">{{ form[item.append] != undefined ? form[item.append] : item.append }}</span>
              </el-form-item>

              <el-form-item v-else-if="item.type=='select'" :label="item.label" :prop="item.prop">
                  <el-select v-model="form[item.prop]" :clearable="item.clearable" :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" :filterable="item.filterable"
                        @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                      <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label" :value="option.value"></el-option>
                  </el-select>
              </el-form-item>
            <div v-else-if="item.type=='tips1'" class="form-group-title"> <span class="ogc-icon-font ogc-icon-salefill"></span> {{ item.tips }}</div>

            <el-form-item v-else-if="item.type=='selectchange'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" :clearable="item.clearable" :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" :filterable="item.filterable" :filter-method="(vals) => { if(item.filterMa != undefined) item.filterMa(vals) }"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label" :value="option.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='select-method'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" :clearable="item.clearable" :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" :filterable="item.filterable" :filter-method="(vals) => { if(item.filterMa != undefined) item.filterMa(vals) }"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label" :value="option.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='captcha'" :label="item.label" :prop="item.prop">
              <el-input placeholder="请输入验证码" v-model="form[item.prop]" class="v-code-input" :clearable="true"></el-input>
              <img :src="captchaFullUrl" alt="" class="v-code" @click="refreshCaptcha">
            </el-form-item>

            <el-form-item v-else-if="item.type=='v-code'" :label="item.label" :prop="item.prop">
              <el-input placeholder="请输入短信验证码" v-model="form[item.prop]" class="v-code-input" :clearable="true"></el-input>
              <el-button alt="" class="v-code" @click="() => { item.click(sendVCode) }" :disabled="sendVCodeTime > 0">{{ sendVCodeTime > 0 ? sendVCodeTime + " 秒" : "发送验证码" }}</el-button>
            </el-form-item>

              <el-form-item v-else-if="item.type=='select-multiple'" :label="item.label" :prop="item.prop">
                <el-select v-model="form[item.prop]" multiple :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" :filterable="item.filterable"
                    @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                    <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label" :value="option.value"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item v-else-if="item.type=='select-multiple-tags'" :label="item.label" :prop="item.prop">
              <el-select collapse-tags v-model="form[item.prop]" multiple :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" :filterable="item.filterable"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label" :value="option.value"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item v-else-if="item.type=='select-group'" :label="item.label" :prop="item.prop">
                <el-select v-model="form[item.prop]" :placeholder="'请选择' + item.label" style="width: 100%" :disabled="item.cannotEidt && isEdit" @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                  <template v-if="item.options.length == 1">
                      <el-option v-for="(option, jndex) in item.options[0].children" :key="jndex" :label="option.label" :value="option.value"></el-option>
                  </template>
                  <template v-else-if="item.options.length > 1">
                      <el-option-group v-for="(group, jndex) in item.options" :key="jndex" :label="group.label">
                          <el-option v-for="item in group.children" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-option-group>
                  </template>
                </el-select>
              </el-form-item>

              <el-form-item v-else-if="item.type=='radio'" :label="item.label" :prop="item.prop">
                  <el-radio-group v-model="form[item.prop]" :disabled="item.cannotEidt && isEdit" @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                      <el-radio-button v-for="(option, jndex) in item.options" :key="jndex" :label="option.value">{{ option.label }}</el-radio-button>
                  </el-radio-group>
              </el-form-item>

              <el-form-item v-else-if="item.type=='date'" :label="item.label" :prop="item.prop">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="form[item.prop]" type="date" :placeholder="'请选择' + item.label" :disabled="item.cannotEidt && isEdit" style="width: 100%"></el-date-picker>
              </el-form-item>

              <el-form-item v-else-if="item.type=='datetime'" :label="item.label" :prop="item.prop">
                  <el-date-picker v-model="form[item.prop]" type="datetime" :placeholder="'请选择' + item.label"  @change="(vals) => { if(item.change != undefined) item.change(vals) }"
                    :disabled="item.cannotEidt && isEdit" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
              <el-form-item v-else-if="item.type=='datetimenos'" :label="item.label" :prop="item.prop">
                <el-date-picker v-model="form[item.prop]" type="datetime" :placeholder="'请选择' + item.label"  @change="(vals) => { if(item.change != undefined) item.change(vals) }"
                                :disabled="item.cannotEidt && isEdit" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
              </el-form-item>
              <el-form-item v-else-if="item.type=='textarea'" :label="item.label" :prop="item.prop">
                  <el-input type="textarea" v-model.trim="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"></el-input>
              </el-form-item>

              <el-form-item v-else-if="item.type=='richtext'" :label="item.label" :prop="item.prop">
                  <fc-editor v-model.trim="form[item.prop]" :text.sync="form[item.optionProp]"></fc-editor>
              </el-form-item>

              <el-form-item v-else-if="item.type=='picture-list'" :label="item.label" :prop="item.prop">
                  <picture-list v-model.trim="form[item.prop]" :type="item.pictureType" :id="form[item.formIdProp]" :limit="item.limit"></picture-list>
              </el-form-item>
              <el-form-item v-else-if="item.type=='word-list'" :label="item.label" :prop="item.prop">
                <word-list v-model.trim="form[item.prop]" :type="item.pictureType" :id="form[item.formIdProp]" :limit="item.limit"></word-list>
              </el-form-item>
              <el-form-item v-else-if="item.type=='transfer'" :label="item.label" :prop="item.prop">
                <el-transfer v-model="form[item.prop]" :data="form[item.optionProp] == undefined ? item.data : form[item.optionProp]" :filterable="item.filterable" :titles="item.titles" :button-texts="item.buttons"></el-transfer>
              </el-form-item>

              <el-form-item v-else-if="item.type=='transfer-mothed'" :label="item.label" :prop="item.prop">
                <el-transfer v-model="form[item.prop]" :data="form[item.optionProp] == undefined ? item.data : form[item.optionProp]" :filterable="item.filterable" :titles="item.titles" :button-texts="item.buttons"></el-transfer>
              </el-form-item>

              <el-form-item v-else-if="item.type=='int'" :label="item.label" :prop="item.prop">
                  <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label"  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }"
                        :clearable="!item.disclearable">
                    <template v-if="item.append" slot="append">{{ form[item.append] != undefined ? form[item.append] : item.append }}</template>
                  </el-input>
              </el-form-item>

              <el-form-item v-else-if="item.type=='number'" :label="item.label" :prop="item.prop">
                  <el-input v-if="item.precision == 3" v-model="form[item.prop]" :placeholder="'请输入' + item.label"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }"
                        :clearable="!item.disclearable"  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}">
                    <template v-if="item.append" slot="append">{{ form[item.append] != undefined ? form[item.append] : item.append }}</template>
                  </el-input>
                  <el-input v-else v-model="form[item.prop]" :placeholder="'请输入' + item.label"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }"
                        :clearable="!item.disclearable"  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}">
                    <template v-if="item.append" slot="append">{{ form[item.append] != undefined ? form[item.append] : item.append }}</template>
                  </el-input>
              </el-form-item>

              <el-form-item v-else-if="item.type=='number-adjustment'" :label="item.label" :prop="item.prop">
                  <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}">
                      <el-select v-model="form[item.optionProp]" slot="prepend" style="width:80px; text-align: center">
                          <el-option label="增加" :value="1"></el-option>
                          <el-option label="减少" :value="-1"></el-option>
                      </el-select>

                      <template slot="append">{{ item.append }}</template>
                  </el-input>
              </el-form-item>

              <el-form-item v-else-if="item.type=='user-no'" :label="item.label" :prop="item.prop">
                  <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable" :disabled="item.cannotEidt && isEdit"
                  @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                      <el-select v-model="form[item.optionProp]" slot="prepend" style="width:120px; text-align: center" :disabled="item.cannotEidt && isEdit"
                      @change="(vals) => { if(item.selectShange != undefined) item.selectShange(vals) }">
                          <el-option label="身份证" :value="0"></el-option>
                          <el-option label="护照" :value="1"></el-option>
                          <el-option label="军人证" :value="2"></el-option>
                          <el-option label="港澳通行证" :value="9"></el-option>
                      </el-select>
                  </el-input>
              </el-form-item>

              <el-form-item v-else-if="item.type=='password'" :label="item.label" :prop="item.prop">
                  <el-input v-model.trim="form[item.prop]" type="password" :placeholder="'请输入' + item.label" :clearable="!item.disclearable" :disabled="item.cannotEidt && isEdit">
                  </el-input>
              </el-form-item>
              <div v-if="item.type=='tips1'" class="form-group-title"><span class="ogc-icon-font ogc-icon-salefill"></span> {{ item.tips1 }}</div>
              <el-form-item v-else :label="item.label" :prop="item.prop">
                  <el-input v-model.trim="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable" :disabled="item.cannotEidt && isEdit"
                    @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                    <template v-if="item.append" slot="append">{{ form[item.append] != undefined ? form[item.append] : item.append }}</template>
                    <template v-else-if="item.appendbutton" slot="append"><el-button @click="item.click">{{ item.appendbutton  }}</el-button></template>
                  </el-input>
              </el-form-item>
          </el-col>
        </template>
      </slot>
    </el-form>
    <div v-else class="form"  v-loading="loading">
        <template v-for="(item, index) in formTemplate">
            <div :key="index" v-if="item.type=='tips'">
                <el-col :span="24">
                    <div class="form-group-title"><span class="ogc-icon-font ogc-icon-salefill"></span> {{ item.tips }}</div>
                </el-col>
            </div>
            <div :key="index" v-else class="display-row">
                <template v-if="showBy(item)">
                    <el-col :span="5" v-if="item.type != 'table'" class="display-label">{{ item.label }} : </el-col>
                    <el-col :span="item.col - 5" v-if="form[item.prop] === null || form[item.prop] === ''">&nbsp;</el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='select' || item.type=='radio'">
                        {{ isnull(search(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
                    </el-col>
                  <el-col :span="item.col - 5" v-else-if="item.type=='select-method'">
                    {{ isnull(search(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
                  </el-col>
                  <el-col :span="item.col - 5" v-else-if="item.type=='selectchange'">
                    {{ isnull(search(item.options, 'id', form[item.prop], 'label'), '&nbsp;') }}
                  </el-col>


                    <el-col :span="item.col - 5" v-else-if="item.type=='select-multiple'">
                        {{ isnull(search(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
                    </el-col>
                    <el-col :span="item.col" v-else-if="item.type=='table'">
                        <el-table :data="form[item.prop]" border style="width: 100%">
                            <el-table-column header-align="center" :show-overflow-tooltip="true" :align="ti.align"
                                v-for="(ti, index) in item.cols" :key="index" :prop="ti.prop" :label="ti.label" :width="ti.width"></el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='select-group'">
                        {{ isnull(searchGroup(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='date'">
                        {{ isnull(showDate(form[item.prop]), '&nbsp;') }}
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='transfer'">
                        {{ isnull(searchTransfer(form[item.optionProp] === undefined ? item.data : form[item.optionProp], 'key', form[item.prop], 'label'), '&nbsp;') }}
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='richtext'">
                        <div v-if="form[item.prop]" v-html="form[item.prop]" class="richtext"></div>
                        <div v-else>暂无数据</div>
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='picture-list'">
                        <div class="picture-group">
                            <el-image v-for="(pic, jndex) in initPictureList(form[item.prop], item.prop)" :key="jndex" style="width: 130px; height: 130px" :src="pic" :preview-src-list="previewPictures(pic, pictures[item.prop])"></el-image>
                            <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传图片</div>
                        </div>
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='word-list'">
                        <div class="picture-group">
                          <div v-for="(pic, jndex) in initWordList(form[item.prop], item.prop)" :key="jndex" style="width: 300px; height: 50px">
                            {{pic}}
                          </div>
                            <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传附件</div>
                        </div>
                    </el-col>
                    <el-col :span="item.col - 5" v-else-if="item.type=='picture'">
                        <div class="picture-group">
                            <el-image style="width: 180px;" :src="initPicture(form[item.prop])" :preview-src-list="[initPicture(form[item.prop])]"></el-image>
                            <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传图片</div>
                        </div>
                    </el-col>
                    <el-col :span="item.col - 5" v-else>
                        {{ form[item.prop] || '&nbsp;' }} <span v-if="item.append !== undefined">{{ form[item.append] !== undefined ? form[item.append] : item.append }}</span>
                    </el-col>
                </template>
            </div>
        </template>
    </div>
</template>

<script type="text/javascript">

import FcEditor from '@/tycomponents/Editor'
import PictureList from '@/tycomponents/PictureList/PictureList'
import WordList from '@/tycomponents/WordList/WordList'

export default {
    components: { FcEditor, PictureList,WordList },
    props: {
        labelWidth: {
            type: String,
            default: '110px'
        },
        rules: {
            type: Object
        },
        form: {
            type: Object
        },
        url: {
            type: String
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        formTemplate: {
          type: Array,
          default: () => []
        }
    },
    data() {
        return {
            first: true,
            pictures:{},
          sendVCodeTime: 0,
        }
    },
    methods: {
        // test(v,item){
        //   if(v){
        //     return item.label.indexOf(v) > -1;
        //   }else{
        //     if(this.isEdit){
        //       return true;
        //     }else{
        //       return item.label.indexOf('123') > -1;
        //     }
        //
        //   }
        // },
        isnull(val, def) {
            return val === null || val == '' ? def : val;
        },
        showBy(item) {
            var can = item.showByProp === undefined;
            if(typeof(item.showByProp) == 'string') {
                can = can ||
                    (
                        item.showValue !== undefined &&
                        this.form[item.showByProp] == item.showValue ||
                        item.showValue === undefined &&
                        this.form[item.showByProp] !== null &&
                        this.form[item.showByProp] !== ''
                    );
            }
            else if(typeof(item.showByProp) == 'object') {
              if(!can) {
                    var tcan = true;
                    for(var i in item.showByProp) {
                        var t = item.showByProp[i];
                        tcan = tcan && (
                            t.value !== undefined && this.form[t.prop] == t.value ||
                            t.value === undefined && this.form[t.prop] !== null &&  this.form[t.prop] !== ''
                        )
                    }
                    can = tcan;
                }
            }

            return can;
        },
        initForm(callback) {
            if(this.formTemplate && this.formTemplate.length > 0) {
                for(var i in this.form){
                    this.form[i] = null;
                    for(var j in this.formTemplate){
                        if(this.formTemplate[j].prop == i && this.formTemplate[j].default != undefined){
                            this.form[i] = this.formTemplate[j].default;
                        }
                        else if(this.formTemplate[j].optionProp == i && this.formTemplate[j].defaultOption != undefined){
                            this.form[i] = this.formTemplate[j].defaultOption;
                        }

                        if(this.formTemplate[j].type == 'picture-list') {

                        }
                        //news
                        if(this.formTemplate[j].type == 'word-list') {
                          this.form['AttachItem'] = []

                        }
                    }
                }
            }
            // this.clearValidate(callback);

        },
        clearValidate(callback) {
            // 清除验证消息
            if(this.canEdit){
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                });
            }

            if(callback && typeof(callback) == 'function') callback();
        },
        vlidateFun(){
          let self = this;
          self.$refs['form'].validate(valid => {
            if (valid) {
              self.$emit('vlidateData',true);
            } else {
              self.$emit('vlidateData',false);
              return false;
            }
          });
        },
        submit() {
            let self = this;
            // 去掉 treeTable 生成的父子级对象
            self.form.parent = undefined;
            self.form.children = undefined;
            self.form.subs = undefined;
            // 提交数据
            self.$refs['form'].validate(valid => {
                if (valid) {
                self.$emit('beforeSaved');
                self.$emit('vlidateData');
                // self.$emit('update:uploading', true);
                  const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                    self.$http.post(self.url, self.form).then(result => {
                        if (result.state == true) {
                            self.$emit('saved');
                        } else {
                            self.$message.error(result.message);
                        }
                    // self.$emit('update:uploading', false);
                      loading.close();
                    }, () => {
                    // self.$emit('update:uploading', false);
                      loading.close();
                        self.$message.error('数据保存失败，请检查您的网络是否可用。');
                    });
                } else {
                    return false;
                }
            });
        },
        search(array, keyProp, key, prop){
            var result = '';
            if(key === undefined || key === null || key === "") {
                result = '';
            }
            else if(typeof(key) == 'string' || typeof(key) == 'number'|| typeof(key) == 'boolean'){
                for(var i in array){
                    if(array[i][keyProp] == key) {
                        result += array[i][prop];
                        break;
                    }
                }
            }
            else {
                for(var i in array){
                    for(var j in key) {
                        if(array[i][keyProp] == key[j]) {
                            result += result == "" ? "" : ", ";
                            result += array[i][prop];
                            break;
                        }
                    }
                }
            }
            return result;
        },
        searchGroup(array, keyProp, key, prop){
            var result = null;
            var find = false;
            for(var i in array){
                for(var j in array[i].children){
                    if(array[i].children[j][keyProp] == key) {
                        result = array[i].children[j][prop];
                        find = true;
                        break;
                    }
                }
                if(find) break;
            }
            return result;
        },
        searchTransfer(array, keyProp, keys, prop){
            var result = "[";
            var find = false;
            for(var j in keys) {
                var key = keys[j];
                if(result != "[") result += "], [";
                for(var i in array){
                    if(array[i][keyProp] == key) {
                        result += array[i][prop];
                        break;
                    }
                }
            }
            result += "]";
            return result;
        },
        showDate(date){
            return new Date(date).format("yyyy年MM月dd日")
        },
        initPictureList(picList, item){
            var list = [];
            for(var i in picList){
                if(typeof(picList[i]) !== "function")
                    list.push(SZH.assets.image + picList[i].Url);
            }
            this.pictures[item] = list;
            return list;
        },
        initWordList(picList, item){
          var list = [];
          for(var i in picList){
            if(typeof(picList[i]) !== "function")
              list.push(picList[i].F_AttachName);
          }
          return list;
        },
        initPicture(url) {
            return SZH.assets.image + url;
        },
        previewPictures(key, pics) {
            var pre = [];
            var result = [];
            var found = false;
            for(var i in pics) {
                if(pics[i] == key) {
                    found = true;
                }
                if(!found) pre.push(pics[i]);
                else result.push(pics[i]);
            }
            return result.concat(pre);
        },
      sendVCode() {
        var me = this;
        me.sendVCodeTime = 60;

        localStorage.setItem("sendvcodetime", 60);

        let index = setInterval(() => {
          if(me.sendVCodeTime > 0) {
            localStorage.setItem("sendvcodetime", --me.sendVCodeTime);
          }
          else {
            clearInterval(index)
            localStorage.removeItem("sendvcodetime")
          }
        }, 1000);
      }
    },
    computed: {
    },
    created() {
    },
    mounted() {
      // this.initForm()
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

.display-row {
    line-height: 40px;
}

.richtext {
    /*border: 1px solid #CCC;*/
}

.display-label {
    text-align: right;
    padding-right: 20px;
    font-weight: 700;
}

.form {
    overflow: hidden;
}

.v-code-input{
  width: calc(100% - 120px - 10px);
  display: inline-block;
}

.v-code {
  float: right;
  width: 120px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/tycomponents/Form/AutoForm.vue